import { notification } from 'antd';
import { useState } from 'react';

import { leasingApi } from '@/components/App/Leasing/api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';

import { refreshOrderData } from '../../../store';

const useAcceptOffer = () => {
  const dispatch = useAppDispatch();
  const { request } = useAppSelector((state) => state.llpLeasingOrder);

  const [acceptLoading, setAcceptLoading] = useState(['']);

  const handleAcceptOffer = async (uuid: string) => {
    setAcceptLoading((prev) => [...prev, uuid]);

    try {
      await leasingApi.submitLeasingOfferForReview(uuid);

      const offer = request?.responses.find((item) => item.uuid === uuid);
      notification.success({
        title: `Заявка успешно отправлена в ${
          offer?.leasingCompany.name || 'компанию'
        }`
      });
      dispatch(refreshOrderData());
    } catch (error) {
      handleError(error, {
        customTitle:
          'Не получилось отправить лизинг на рассмотрение. Пожалуйста, попробуйте позже'
      });
    }

    setAcceptLoading((prev) => [...prev].filter((item) => item !== uuid));
  };

  return { handleAcceptOffer, acceptLoading };
};

export default useAcceptOffer;
